var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"no-border-padding",attrs:{"fill-height":"","fluid":""}},[_c('router-view')],1)],1),_c('v-footer',{attrs:{"padless":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('small',[_vm._v("© "+_vm._s(new Date().getFullYear())+" BAScloud")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }